import React, { Component } from "react";
import _ from "lodash";

// Data from JSON
import formFields from "../../../User/data/formFields.json";
import dataColombia from "../../../User/data/colombia.json";

class Parameterization extends Component {
  constructor(props) {
    super(props);
    const filtered = _.filter(formFields, "parameterization");
    const keys = _.map(filtered, ({ name }) => name);
    const emptyString = _.map(filtered, () => "");
    const initialState = _.zipObject(keys, emptyString);
    this.state = {
      ...initialState,
      active: false
    };
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleParentStateCallback = this.handleParentStateCallback.bind(this);
  }
  componentDidMount() {
    const { __typename, ...parameterization } = this.props.parameterization;
    // remove null values from parent
    const newState = _.omitBy(parameterization, _.isNil);
    this.setState(newState);
  }
  handleParentStateCallback() {
    this.props.parentStateCallback(this.state);
  }
  handleOnChange(e) {
    const { name, value, checked } = e.target;
    if (name === "active") {
      return this.setState({
        [name]: checked
      });
    }
    this.setState({
      [name]: value
    });
  }
  departamento() {
    const subset = _.map(dataColombia, i =>
      _.pick(i, ["c_digo_dane_del_departamento", "departamento"])
    );
    const uniq = _.uniqWith(subset, _.isEqual);
    return _.orderBy(uniq, "departamento");
  }
  renderFields() {
    const filtered = _.filter(formFields, "parameterization");
    return _.map(filtered, ({ type, label, name, options }, i) => {
      if (type === "date") {
        return (
          <div className={`item-${i} form-group`} key={i}>
            <label htmlFor={i}>{label}:</label>
            <input
              type={type}
              name={name}
              id={i}
              value={this.state[name]}
              onChange={this.handleOnChange}
              className="form-control"
              required
            />
          </div>
        );
      } else if (type === "external") {
        if (options.level === 1) {
          const payload = this.departamento();
          return (
            <div className={`item-${i} form-group`} key={i}>
              <label htmlFor={i}>{label}:</label>
              <select
                name={name}
                id={i}
                value={this.state[name]}
                onChange={this.handleOnChange}
                className="form-control"
              >
                <option value="">-- Selecione una opción --</option>
                {_.map(payload, i => (
                  <option
                    value={i.c_digo_dane_del_departamento}
                    key={i.departamento}
                  >
                    {i.departamento}
                  </option>
                ))}
              </select>
            </div>
          );
        }
      } else if (type === "select") {
        return (
          <div className={`item-${i} form-group`} key={i}>
            <label htmlFor={i}>{label}:</label>
            <select
              name={name}
              id={i}
              value={this.state[name]}
              onChange={this.handleOnChange}
              className="form-control"
            >
              <option value="">-- Selecione una opción --</option>
              {_.map(options, option => (
                <option value={option.value} key={option.name}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        );
      } else if (type === "number" || type === "tel") {
        return (
          <div className={`item-${i} form-group`} key={i}>
            <label htmlFor={i}>{label}:</label>
            <input
              type={type}
              name={name}
              id={i}
              value={this.state[name]}
              onChange={this.handleOnChange}
              className="form-control"
              required
            />
            <small id={i} className="form-text text-muted">
              Este campo tiene que ser un número entero. No utilice espacios u
              otros caracteres.
            </small>
          </div>
        );
      } else {
        return (
          <div className={`item-${i} form-group`} key={i}>
            <label htmlFor={i}>{label}:</label>
            <input
              type={type}
              name={name}
              id={i}
              value={this.state[name]}
              onChange={this.handleOnChange}
              className="form-control"
              required
            />
          </div>
        );
      }
    });
  }
  render() {
    return (
      <div className="card card-body bg-light">
        <div className="form-check">
          <input
            type="checkbox"
            name="active"
            id="activar"
            checked={this.state.active}
            onChange={this.handleOnChange}
            className="form-check-input"
          />
          <label htmlFor="activar">Activar</label>
        </div>
        <fieldset disabled={!this.state.active && true}>
          {this.renderFields()}
        </fieldset>
        <div className="form-group">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={this.handleParentStateCallback}
          >
            Guardar parámetros
          </button>
        </div>
      </div>
    );
  }
}

export default Parameterization;



// WEBPACK FOOTER //
// ./src/components/Survey/admin/Parameterization/index.js